var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSocialMediaIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.04 16.89C16.56 16.42 17.24 16.12 18 16.12C19.61 16.12 20.92 17.43 20.92 19.04C20.92 20.65 19.61 21.96 18 21.96C16.39 21.96 15.08 20.65 15.08 19.04C15.08 18.82 15.11 18.6 15.16 18.39L8.04 14.23C7.5 14.73 6.79 15.04 6 15.04C4.34 15.04 3 13.7 3 12.04C3 10.38 4.34 9.04004 6 9.04004C6.79 9.04004 7.5 9.35004 8.04 9.85004L15.09 5.74004C15.04 5.51004 15 5.28004 15 5.04004C15 3.38004 16.34 2.04004 18 2.04004C19.66 2.04004 21 3.38004 21 5.04004C21 6.70004 19.66 8.04004 18 8.04004C17.21 8.04004 16.5 7.73004 15.96 7.23004L8.91 11.34C8.96 11.57 9 11.8 9 12.04C9 12.28 8.96 12.51 8.91 12.74L16.04 16.89ZM19 5.04004C19 4.49004 18.55 4.04004 18 4.04004C17.45 4.04004 17 4.49004 17 5.04004C17 5.59004 17.45 6.04004 18 6.04004C18.55 6.04004 19 5.59004 19 5.04004ZM6 13.04C5.45 13.04 5 12.59 5 12.04C5 11.49 5.45 11.04 6 11.04C6.55 11.04 7 11.49 7 12.04C7 12.59 6.55 13.04 6 13.04ZM17 19.06C17 19.61 17.45 20.06 18 20.06C18.55 20.06 19 19.61 19 19.06C19 18.51 18.55 18.06 18 18.06C17.45 18.06 17 18.51 17 19.06Z",
    fill: "#37539D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSocialMediaIcon);
export default __webpack_public_path__ + "static/media/social-media-icon.75681ba5f6f7b12335f85c4aa755c24b.svg";
export { ForwardRef as ReactComponent };